import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface StepHeaderProps {
    titleId: string;
    descriptionId?: string;
    actions?: React.ReactNode;
}

export default function StepHeader({
    titleId,
    descriptionId,
    actions,
}: StepHeaderProps) {
    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={0.5}
                mx={2}
                pt={1.5}
            >
                <Typography variant="workflowTitle">
                    <FormattedMessage id={titleId} />
                </Typography>
                {actions}
            </Box>
            {descriptionId && (
                <Typography fontSize={12} color="text.secondary" px={2}>
                    <FormattedMessage id={descriptionId} />
                </Typography>
            )}
        </Box>
    );
}
